import React from "react";

const Kite = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M32.656 2H18.253l7.201 7.202L32.656 2zM34.001 17.747V3.344L26.8 10.545 34 17.747zM27.629 14.059l2 5.997 3.14-.857-5.14-5.14zM12.66 24.682l15.135-4.127-2.751-8.256L12.66 24.682zM24.115 10.543L16.802 3.23l-5.485 20.111 12.798-12.798zM12.658 24.685l-1.343-1.343-1.524 1.524-2.651-2.652-1.343 1.343 2.652 2.652-1.506 1.505-1.702-1.702L3.9 27.355 5.6 29.056 2 32.657 3.343 34l3.6-3.6L8.646 32.1l1.342-1.342-1.702-1.702L9.79 27.55l2.652 2.652 1.343-1.343-2.652-2.651 1.524-1.524z"
            fill={fill}
        />
    </svg>
);

export default Kite;